import React, { Component } from "react";
import { Link } from "gatsby";
import "../css/headerStyle.css";
import DownArrow from "../images/downarrowmenu.svg";
import { Helmet } from "react-helmet";



function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results;
  if (typeof window !== `undefined`) {
    results = regex.exec(window.location.search);
  }
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}
var device = "desktop";
class Header extends Component {
  constructor() {
    super();
    this.state = {
      hideDiv: false,
    };
  }

  componentDidMount() {
    const script = document.createElement("script");
    script.src = "https://cdn.gumlet.com/gumlet.js/2.0/gumlet.min.js";
    script.async = true;
    script.onload = () => this.scriptLoaded();
    document.body.appendChild(script);
    var windowWidth;
    if (typeof window !== `undefined`) {
      windowWidth = parseInt(window.innerWidth);
      console.log("window width -->",windowWidth);
    }

    // if (windowWidth > 1200) device = "Desktop";
    // else if (windowWidth > 520) device = "Tablet";
    // else device = "Mobile";
    // localStorage.setItem("device",device)
  }

  scriptLoaded() {
    window.GUMLET_CONFIG = {
      hosts: [
        {
          current: "res.cloudinary.com",
          gumlet: "twinhealth.gumlet.com",
        },
      ],
      lazy_load: true,
    };
    window.gumlet.init(window.GUMLET_CONFIG);
  }
  myFunc = () => {
    this.setState({
      hideDiv: !this.state.hideDiv,
    });
  };

  render() {
    return (
      <div>
        <div class="topnav desktop" id="desktopNav" >
          <Link to="/">
          <img
            data-src="https://res.cloudinary.com/image/upload/v1601884178/Home/header-logo_b3hpbs.png"
            alt="logo"
            className="mainLogo lazyload"
          /></Link>{" "}
          <div class="mainHeaderDiv">
            {/* <div class="dropdown ">
              <button class="dropbtn padHeader">
                TREATMENT
                <i class="">
                  {" "}
                  <img
                    data-src=" https://res.cloudinary.com/image/upload/v1603272597/Home/downArrow_mng2gr.png"
                    alt="logo"
                    className="colorWhite mainLogo lazyload"
                  />{" "}
                </i>
              </button>
              <div class="dropdown-content">
                <a href="#">Link 1</a>
                <a href="#">Link 2</a>
                <a href="#">Link 3</a>
              </div>
            </div> */}
            {/* <div class="dropdown ">
              <button class="dropbtn padHeader">
                TECHNOLOGY
                <i class="">
                  {" "}
                  <img
                    data-src=" https://res.cloudinary.com/image/upload/v1603272597/Home/downArrow_mng2gr.png"
                    alt="logo"
                    className="mainLogo lazyload"
                  />{" "}
                </i>
              </button>
              <div class="dropdown-content">
                <a href="#">Link 1</a>
                <a href="#">Link 2</a>
                <a href="#">Link 3</a>
              </div>
            </div> */}
            {/* <a href="" class="padHeader">
              PATIENT SUCCESS
            </a> */}
            {/* <div class="dropdown ">
              <button class="dropbtn padHeader">
                DOCTORS
                <i class="">
                  {" "}
                  <img
                    data-src=" https://res.cloudinary.com/image/upload/v1603272597/Home/downArrow_mng2gr.png"
                    alt="logo"
                    className="mainLogo lazyload"
                  />{" "}
                </i>
              </button>
              <div class="dropdown-content">
                <a href="#">Link 1</a>
                <a href="#">Link 2</a>
                <a href="#">Link 3</a>
              </div>
            </div> */}
              {/* <a href="" class="padHeader">
             HOME
            </a> */}
            <Link to='/' class="padHeader"> HOME</Link>
            <Link to='/webinar/' class="padHeader marginLeftHeader"> WEBINAR</Link>
            {/* <a href="" class="padHeader">
            WEBINAR
            </a> */}
            {/* <a href="" class="padHeader">
            FREE CONSULTATION
            </a> */}
              {/* <div className="navMobile">
                {" "}
                <a>WEBINAR</a>
              </div>
              <div className="navMobile">
                {" "}
                <a>FREE CONSULTATION</a>
              </div> */}
                <Link to='/free-consultation/'  className="consultBtnStructure padHeader"> CONSULT NOW</Link>
            {/* <a class="consultBtnStructure padHeader" href="">
              CONSULT NOW
            </a> */}

            <a href="" class="icon"></a>
          </div>
        </div>

        <div ref={this.scrollDiv} class="topnav responsive Mobile" id="myTopnav">
          <div className="floatImg_left">
            <Link to="/">
            <img
              data-src="https://res.cloudinary.com/image/upload/v1601884178/Home/header-logo_b3hpbs.png"
              alt="logo"
              
              className="imgWidth mainLogo lazyload"
            /></Link>{" "}
          </div>
          <div className="floatImg_right">

            <div > <Link to='/free-consultation/' className="consultNow_Btn_Mobile">CONSULT NOW</Link></div>
          </div>

          {this.state.hideDiv == true ? (
            <div class="mainHeaderDiv">
              {/* <div class="dropdown ">
                <button class="dropbtn">
                  TREATMENT
                  <i class="">
                    {" "}
                    <img
                      data-src=" https://res.cloudinary.com/image/upload/v1603272597/Home/downArrow_mng2gr.png"
                      alt="logo"
                      className="mainLogo lazyload"
                    />{" "}
                  </i>
                </button>
                <div class="dropdown-content">
                  <a href="#">Link 1</a>
                  <a href="#">Link 2</a>
                  <a href="#">Link 3</a>
                </div>
              </div>
              <div class="dropdown ">
                <button class="dropbtn">
                  TECHNOLOGY
                  <i class="">
                    {" "}
                    <img
                      data-src=" https://res.cloudinary.com/image/upload/v1603272597/Home/downArrow_mng2gr.png"
                      alt="logo"
                      className="mainLogo lazyload"
                    />{" "}
                  </i>
                </button>
                <div class="dropdown-content">
                  <a href="#">Link 1</a>
                  <a href="#">Link 2</a>
                  <a href="#">Link 3</a>
                </div>
              </div> */}
              {/* <div className="navMobile">
                {" "}
                <a>PATIENT SUCCESS</a>
              </div> */}
              <div className="navMobile firstHeader">
                {" "}
                <Link to='/'>HOME</Link>
                {/* <a>HOME</a> */}
              </div>
              <tr/>
              <div className="navMobile">
                {" "}
                <Link to='/webinar/'>WEBINAR</Link>
                {/* <a>WEBINAR</a> */}
              </div>
              {/* <div className="navMobile">
                {" "}
                <a>FREE CONSULTATION</a>
              </div> */}
              {/* <div class="dropdown ">
                <button class="dropbtn">
                  DOCTORS
                  <i class="">
                    {" "}
                    <img
                      data-src=" https://res.cloudinary.com/image/upload/v1603272597/Home/downArrow_mng2gr.png"
                      alt="logo"
                      className="mainLogo lazyload"
                    />{" "}
                  </i>
                </button>
                <div class="dropdown-content">
                  <a href="#">Link 1</a>
                  <a href="#">Link 2</a>
                  <a href="#">Link 3</a>
                </div>
              </div> */}
            </div>
          ) : (
            <div></div>
          )}
        
          <a class="icon"
           onClick={this.myFunc}>
            {/* &#9776; */}
            <img
            data-src="https://res.cloudinary.com/image/upload/v1603792886/Free-consulation/menu_ggssxo.svg"
            alt="logo"
            className=" hambergerWidth mainLogo lazyload"
          />{" "}
          </a>
        </div>
      </div>
    );
  }
}

export default Header;
